// if this is turned on, self-checkin will be turned off and instead people will see the automatic booking with membership screen
export const isAutomaticBookingEnabled = (hostId: number) =>
    [5827, 12676, 10676, 12090, 30017, 24084, 19515, 18609, 5610, 37147, 38874, 43824, 82856].includes(hostId)

export const isCheckinViaEmail = (hostId: number) => [7220, 10781, 12676].includes(hostId)

export const isOnDemandHidden = (hostId: number) => ![18609].includes(hostId)
